var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHearth = function SvgHearth(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "19px",
    viewBox: "0 0 21 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Stroke 31")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LIbraway_loggato",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ricetta_new",
    transform: "translate(-1309.000000, -392.000000)",
    className: "main",
    stroke: "#1D1D1B",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1319.49984,394.966729 C1317.96918,393.155274 1315.76673,392.527254 1313.64294,393.367794 C1311.39744,394.257092 1309.35868,396.909087 1310.18938,400.630042 C1311.54094,406.684476 1318.88864,409.809739 1319.20062,409.940113 C1319.29575,409.980921 1319.39886,410 1319.5009,410 C1319.60241,410 1319.70552,409.980921 1319.80066,409.940113 C1320.11317,409.809739 1327.45927,406.684476 1328.81083,400.630042 C1329.641,396.909087 1327.60224,394.257092 1325.35727,393.367794 C1323.23136,392.527254 1321.02891,393.155804 1319.49984,394.966729 Z",
    id: "Stroke-31"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHearth, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hearth.52c5c427.svg";
export { ForwardRef as ReactComponent };